'use strict'

define ['./closeAccountModal.css'], () ->
  ($q, $scope, $rootScope, $http, $state, $localStorage, RENTAPPLICATION_API_URL, HOST) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.allow_close = false
    $scope.reasons = [
      {
        name: "I’m an applicant; I didn’t mean to create a landlord account"
        additional: []
      },
      {
        name: "Rent application is too expensive"
        additional: [
          {
            sub_title : "What is your suggested price for Credit Reports (currently $19.00)?"
          },
          {
            sub_title: "What is your suggested price for Criminal Reports (currently $10.00)?"
          },
          {
            sub_title: "What is your suggested price for Eviction Reports (currently $10.00)?"
          },
          {
            sub_title: "What is your suggested price for My Payments Activation (currently $34.95)?"
          }
        ]
      },
      {
        name: "I find your product too confusing/complicated"
        additional: [
          {
            sub_title : "Would you like to provide us with more information?"
          }
        ]
      },
      {
        name: "You don’t offer what I’m looking for"
        additional: [
          {
            sub_title : "What service and/or features are looking for?"
          }
        ]
      },
      {
        name: "Other"
        additional: [
          {
            sub_title : "Why have you decided to close your account"
          }
        ]
      }
    ]
    $scope.$watch 'reasons', (->
      $scope.allow_close = false
      for reason in $scope.reasons
        if reason.checked == true
          if reason.additional.length == 0
            $scope.allow_close = true
          for sub in reason.additional
            if sub.value
              $scope.allow_close = true

    ), true

    $scope.toggle_checked = (reason) ->
      reason.checked = !reason.checked



    $scope.reasons_checked = {}
    $scope.close_account = ->
      console.log $scope.reasons
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/close_account/",
        reasons: $scope.reasons
      .then ->
        $localStorage.$reset()
        $rootScope.user = undefined
        window.location.replace(HOST);
      .catch (r) ->
        Flash.create("danger", 'Unfortunately, an error has occured in processing this request. Please try again.')



// WEBPACK FOOTER //
// ./directives/closeAccountModal/closeAccountModal.coffee